import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Facility } from 'src/app/services/firebase-utilities.service';
import { SharingPatientId } from '../sharing-setup/sharing-setup.component';

export interface ChangeTargetDialogData {
  facilities: Facility[];
  selectedFacility: SharingPatientId | null;
}

@Component({
  selector: 'app-change-target-dialog',
  templateUrl: './change-target-dialog.component.html',
  styleUrls: ['./change-target-dialog.component.scss'],
  standalone: false
})
export class ChangeTargetDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ChangeTargetDialogData,
    private dialogRef: MatDialogRef<ChangeTargetDialogComponent>
  ) {}

  onFacilitySelected(facility: Facility): void {
    this.dialogRef.close(facility);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
